export const Reminder = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g mask='url(#mask0_595_2384)'>
        <path
          d='M2 10.0002C2 8.33353 2.37083 6.80436 3.1125 5.4127C3.85417 4.02103 4.85 2.86686 6.1 1.9502L7.275 3.5502C6.275 4.28353 5.47917 5.20853 4.8875 6.3252C4.29583 7.44186 4 8.66686 4 10.0002H2ZM20 10.0002C20 8.66686 19.7042 7.44186 19.1125 6.3252C18.5208 5.20853 17.725 4.28353 16.725 3.5502L17.9 1.9502C19.15 2.86686 20.1458 4.02103 20.8875 5.4127C21.6292 6.80436 22 8.33353 22 10.0002H20ZM4 19.0002V17.0002H6V10.0002C6 8.61686 6.41667 7.3877 7.25 6.3127C8.08333 5.2377 9.16667 4.53353 10.5 4.2002V3.5002C10.5 3.08353 10.6458 2.72936 10.9375 2.4377C11.2292 2.14603 11.5833 2.0002 12 2.0002C12.4167 2.0002 12.7708 2.14603 13.0625 2.4377C13.3542 2.72936 13.5 3.08353 13.5 3.5002V4.2002C14.8333 4.53353 15.9167 5.2377 16.75 6.3127C17.5833 7.3877 18 8.61686 18 10.0002V17.0002H20V19.0002H4ZM12 22.0002C11.45 22.0002 10.9792 21.8044 10.5875 21.4127C10.1958 21.021 10 20.5502 10 20.0002H14C14 20.5502 13.8042 21.021 13.4125 21.4127C13.0208 21.8044 12.55 22.0002 12 22.0002ZM8 17.0002H16V10.0002C16 8.9002 15.6083 7.95853 14.825 7.1752C14.0417 6.39186 13.1 6.0002 12 6.0002C10.9 6.0002 9.95833 6.39186 9.175 7.1752C8.39167 7.95853 8 8.9002 8 10.0002V17.0002Z'
          fill='#1C1B1F'
        />
      </g>
    </svg>
  );
};
